import React, { useContext, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Person, People, Collection, ChevronDown, ChevronLeft, ChevronRight, Archive } from 'react-bootstrap-icons'
import Divider from '../Campaign/CampaignPageParts/SIdebarParts/Divider'
import CreateOptions from './CampaignsSidebarParts/CreateOptions'
import ClientsList from './CampaignsSidebarParts/ClientsList'
import { BrowseContext } from '../../../contexts/BrowseContext'
import NewClientModal from './NewClientModal'
import NewEditFolderModal from './NewEditFolderModal'
import DeleteClientModal from './DeleteClientModal'
import EditClientModal from './EditClientModal'
import UpdateCampaignFolderModal from './UpdateCampaignFolderModal'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSidebarCollapse } from '../../../contexts/SidebarCollapseContext'

export default observer(function CampaignsSidebar() {
  const {
    browseState,
    resultsFilter,
    openCreateClient,
    openCreateFolder,
    openDeleteClient,
    openEditClient,
    openEditFolder,
    openUpdateCampaignFolder
  } = useContext(BrowseContext)

  const navigate = useNavigate()
  const location = useLocation()
  const { isCollapsed, toggleCollapse } = useSidebarCollapse()

  const [openCreateOptions, setOpenCreateOptions] = useState(false)

  const isArchivePage = location.pathname === '/project_manager/campaigns/archived'

  const reCenterBrowse = () => {
    if (location.pathname === '/project_manager/campaigns' || isArchivePage) return

    navigate('/project_manager/campaigns')
  }

  return (
    <div className={`fixed ${isCollapsed ? 'w-16' : 'w-56'} h-full top-0 left-0 bg-white dark:bg-rb-dark-mode z-10 border-r-2 border-rb-widget-border dark:border-rb-dark-mode-lighter transition-all duration-300`}>
      <section className={`pt-16 ${isCollapsed ? 'pl-2' : 'pl-3'}`}>
        {!isCollapsed && (
          <>
            <div className="pr-4 flex items-center justify-between">
              <p className='text-xs rb-text-muted uppercase'>View options</p>
              <button
                onClick={toggleCollapse}
                className="p-1 rounded-md hover:bg-gray-200 dark:hover:bg-rb-dark-mode-lighter dark:text-white"
                title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
              >
                {isCollapsed ? <ChevronRight className="text-sm" /> : <ChevronLeft className="text-sm" />}
              </button>
            </div>
            <p className='rb-text-muted'>Filter projects</p>
          </>
        )}

        <div className={`flex ${isCollapsed ? 'flex-col gap-2' : 'gap-3'} mt-2 mb-2 items-center justify-center`}>
        {isCollapsed && (
          <button
            onClick={toggleCollapse}
            className="p-1 rounded-md hover:bg-gray-200 dark:hover:bg-rb-dark-mode-lighter dark:text-white"
            title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            {isCollapsed ? <ChevronRight className="text-sm" /> : <ChevronLeft className="text-sm" />}
          </button>
          )}
          <Person
            className={`text-4xl p-2 rounded-lg cursor-pointer ${resultsFilter === 'own' ? 'bg-rb-green text-white dark:text-rb-dark-mode' : 'dark:text-white'}`}
            onClick={() => {
              browseState.resultsFilter = 'own'
              reCenterBrowse()
            }}
            title={isCollapsed ? 'Own' : undefined}
          />
          <People
            className={`text-4xl p-2 rounded-lg cursor-pointer ${resultsFilter === 'collaborator' ? 'bg-rb-green text-white dark:text-rb-dark-mode' : 'dark:text-white'}`}
            onClick={() => {
              browseState.resultsFilter = 'collaborator'
              reCenterBrowse()
            }}
            title={isCollapsed ? 'Collaborator' : undefined}
          />
          <Collection
            className={`text-4xl p-2 rounded-lg cursor-pointer ${resultsFilter === 'all' ? 'bg-rb-green text-white dark:text-rb-dark-mode' : 'dark:text-white'}`}
            onClick={() => {
              browseState.resultsFilter = 'all'
              reCenterBrowse()
            }}
            title={isCollapsed ? 'All' : undefined}
          />
        </div>
      </section>
      {!isCollapsed && <Divider />}
      <section className={`${isCollapsed ? 'pl-4 pr-2 pt-4' : 'p-3'} relative`}>
        {!isCollapsed ? (
          <>
            <button
              className='flex gap-2 items-center justify-center bg-rb-green rounded-md p-1 text-white w-full dark:text-rb-dark-mode'
              onClick={() => setOpenCreateOptions(!openCreateOptions)}
            >
              <span className='text-white dark:text-rb-dark-mode'>Create new </span>
              <ChevronDown className='dark:text-rb-dark-mode' />
            </button>
            <CreateOptions
              isOpen={openCreateOptions}
              onClose={() => setOpenCreateOptions(false)}
            />
            <section>
              <h2 className='text-xs uppercase rb-text-muted p-2'>Favourite Campaigns</h2>
              {/* <FavCampaignsList /> */}
              <button
                type='button'
                className={`w-full flex items-center gap-2 p-2 mt-1 rounded-md text-sm ${isArchivePage ? 'bg-rb-grey dark:bg-rb-dark-mode-lighter font-bold dark:text-white' : 'dark:text-white hover:bg-rb-grey dark:hover:bg-rb-dark-mode-lighter'}`}
                onClick={() => navigate('/project_manager/campaigns/archived')}
              >
                <Archive />
                <span>Archive</span>
              </button>
              <h2 className='text-xs uppercase rb-text-muted p-2'>Clients</h2>
              <ClientsList />
            </section>
          </>
        ) : (
          <div className={`flex ${isCollapsed ? 'flex-col gap-2' : 'gap-3'} mt-2 mb-2 items-center justify-center`}>
            <button
              className='flex items-center justify-center bg-rb-green rounded-md p-2 text-white w-full dark:text-rb-dark-mode'
              onClick={() => setOpenCreateOptions(!openCreateOptions)}
              title="Create new"
            >
              <ChevronDown className='dark:text-rb-dark-mode' />
            </button>
          </div>
        )}
        {isCollapsed && (
          <CreateOptions
            isOpen={openCreateOptions}
            onClose={() => setOpenCreateOptions(false)}
          />
        )}

        { openCreateClient && <NewClientModal /> }
        { openEditClient && <EditClientModal /> }
        { openDeleteClient && <DeleteClientModal /> }
        { openCreateFolder && <NewEditFolderModal /> }
        { openEditFolder && <NewEditFolderModal /> }
        { openUpdateCampaignFolder && <UpdateCampaignFolderModal /> }
      </section>
    </div>
  )
})

